import { useMemo, useState, useEffect } from 'react';
import { Dropdown, Tooltip, Whisper } from 'rsuite';
import { Button } from '../../../../../ds-components';
import { Setting2 } from 'iconsax-react';
import './CollectionHeader.scss';
import { exportCollectionToPDF } from '../../../../../services/collections';
import ManagePeopleCollectionButton from '../ManagePeopleCollectionButton/ManagePeopleCollectionButton';
import ShareCollectionWithCompanyButton from '../ShareCollectionWithCompanyButton/ShareCollectionWithCompanyButton';
import EditCollectionButton from '../EditCollectionButton/EditCollectionButton';
import RemoveCollectionButton from '../RemoveCollectionButton/RemoveCollectionButton';
import { updateCheckllist } from '../../../../../services/checklist';
import { ExportReport } from './ExportReport';
import DrawerCollection from '../ModalCollection/DrawerCollection';
import { useHistory, useLocation } from 'react-router-dom';
import IconStar from '../../../../../assets/svgs/resume-inteiro-teor-black.svg';
import { requester } from '../../../../../requesters';

type CollectionHeaderProps = {
  collection: any;
  reloadAction: any;
};

const renderToggleMenu = (props: any, ref: any) => {
  return (
    <Whisper placement="top" speaker={<Tooltip>Configurações</Tooltip>}>
      <div className="button-shared-style" {...props} ref={ref} size="xs">
        <Setting2 size={24} color="#475467" />
        <span> Opções</span>
      </div>
    </Whisper>
  );
};

const CollectionHeader = ({
  collection,
  reloadAction,
}: CollectionHeaderProps) => {
  const history = useHistory();
  const location = useLocation();

  const [hasPermission, setSummaryPermission] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const openDrawer = queryParams.get('openDrawer');
  const [isDrawerOpen, setDrawerOpen] = useState(openDrawer === 'true');
  const [progressStatus, setprogressStatus] = useState({
    progress: 100,
    total: 1,
    processed: 1,
  });

  const checkPermission = async () => {
    try {
      const response = await requester.segmentation.validateAction('rag');

      const permission =
        response.status === 400 || response.status === 403
          ? response.has_permission
          : response;

      setSummaryPermission(permission);

      localStorage.setItem(
        'actions_permission',
        JSON.stringify({ rag: permission }),
      );
    } catch (error) {
      console.error('Erro ao verificar permissão:', error);
      setSummaryPermission(false);
      localStorage.setItem('actions_permission', JSON.stringify({}));
    }
  };

  useEffect(() => {
    checkPermission();
  }, []);

  const handleOpen = () => {
    setDrawerOpen(true);
    history.push({
      pathname: window.location.pathname,
      search: '?openDrawer=true',
    });
  };

  const updTour = async () => {
    const check = JSON.parse(localStorage.getItem('checklist') as string);
    if (!check?.trail?.report) {
      // await updateCheckllist(check?.id, 'report');
    }
  };

  useEffect(() => {
    requester.collections.getCardsRagProgress(2137).then((response) => {
      try {
        const _progress = Math.round(
          (response.processed / response.total) * 100,
        );
        setprogressStatus({
          progress: _progress,
          total: response.total,
          processed: response.processed,
        });
      } catch {
        setprogressStatus({ progress: 100, total: 1, processed: 1 });
      }
    });
  }, []);

  const handleClickExport = async (collectionId: any, isDefault: boolean) => {
    try {
      await exportCollectionToPDF(
        userId,
        collectionId,
        collection.name,
        isDefault,
      );
      updTour();
    } catch (error) {
      console.error(error);
    }
  };

  const userId = useMemo(() => localStorage.getItem('user'), []);

  if (!collection) return <div></div>;

  return (
    <div>
      {hasPermission && (
        <div className="card-two mb-8">
          <div className="bg-white border border-solid border-1 border-gray-100 rounded-xl shadow-md px-6 py-4 flex items-center justify-between gap-4">
            {/* Ícone à esquerda */}
            <img
              // src="/stars-group.png"
              src={IconStar}
              alt=""
              className="w-11 h-11 rounded-full bg-[#101828] p-1 flex-shrink-0"
            />

            {/* Texto (título + subtítulo) */}
            <div className="flex flex-col justify-center text-left flex-1">
              <div className="flex items-center gap-2">
                <h1 className="text-base font-semibold text-[#101828] mb-1">
                  GPTuri
                </h1>
                <span className="text-sm text-[#FFFFFF] bg-[#FDB022] font-semibold mb-2 px-2 py-[1px] rounded-xl">
                  Beta
                </span>
              </div>
              <span className="text-sm text-[#475467] leading-relaxed">
                Facilite sua pesquisa! Use o GPTuri para fazer perguntas
                diretamente às decisões que você já selecionou e receba
                respostas inteligentes em segundos.
              </span>
            </div>

            {/* Botão à direita */}
            <button
              className="ml-auto flex items-center gap-2 bg-[#101828] text-white text-sm mt-4 py-2 px-4 rounded-md hover:opacity-90 transition"
              onClick={handleOpen}
            >
              <img src={IconStar} alt="Ícone de estrelas" className="w-6 h-6" />
              <span className="text-sm font-medium text-[#FFFFFF]">
                Solicitar serviço com IA
              </span>
            </button>
          </div>

          <div>
            <div
              className={`bg-white rounded-xl shadow-md border border-solid border-1 border-gray-100 ${progressStatus.progress === 100 ? 'pl-7 pr-16 py-8' : 'px-6 py-5'} z flex flex-col gap-4`}
            >
              <div className="flex items-center gap-3">
                <img
                  src={
                    progressStatus.progress === 100
                      ? '/check-image.png'
                      : '/newArrow.png'
                  }
                  alt=""
                  className="w-11 h-11 rounded-full bg-[#101828] p-1"
                />
                <div>
                  <h1 className="text-base font-semibold text-[#101828] mb-1">
                    {progressStatus.progress === 100
                      ? 'Todas as decisões foram processadas'
                      : 'Estamos processando as novas decisões inseridas'}
                  </h1>
                  <span className="text-sm text-[#475467] leading-relaxed">
                    {progressStatus.progress === 100 ? (
                      <>
                        Nossa IA já aprendeu com todas as decisões desta
                        coleção.
                      </>
                    ) : (
                      <>
                        <strong>
                          Processando {progressStatus.processed} de{' '}
                          {progressStatus.total}{' '}
                          {progressStatus.total > 13 ? 'decisões' : 'decisão'}.
                        </strong>{' '}
                        Nossa inteligência está aprendendo com as suas decisões,
                        aguarde alguns instantes.
                      </>
                    )}
                  </span>
                </div>
              </div>

              {progressStatus.progress !== 100 && (
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-blue-500 rounded-full transition-all duration-300 ease-in-out"
                    style={{ width: `${progressStatus.progress}%` }}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="collection-header-content flex items-end">
        <div className="header_description">
          <h6 className="font-semibold">Descrição:</h6>
          {collection.description !== '' ? (
            <p className="description">{collection.description}</p>
          ) : (
            <p className="no-description">
              nenhuma descrição adicionada a essa coleção
            </p>
          )}
        </div>

        <div className="header_actions">
          <Dropdown
            placement="bottomStart"
            renderToggle={renderToggleMenu}
            id="nav-menu-options"
          >
            <Dropdown.Item>
              <ShareCollectionWithCompanyButton
                //@ts-ignore
                publicToCompany={collection.public_to_company}
                collection={collection}
                collectionId={collection.id}
                collectionTitle={collection.name}
                context={'Single Collection'}
                onSearch={reloadAction}
                style={{
                  margin: 'auto',
                  padding: '14px 4px',
                }}
                TabOrInside={'inside_collection'}
              />
            </Dropdown.Item>
            <Dropdown.Item>
              <EditCollectionButton
                collectionId={collection.id}
                style={{ width: '100%' }}
                collectionTitle={collection.name}
                collectionDescription={collection.description}
                context={'Single Collection'}
                onSearch={reloadAction}
                pageView={'inside_collection'}
              />
            </Dropdown.Item>
            {parseInt(collection.owner.id) ===
            parseInt(localStorage.getItem('user') as string) ? (
              <Dropdown.Item>
                <RemoveCollectionButton
                  //@ts-ignore
                  collectionId={collection.id}
                  style={{ width: '100%' }}
                  context={'Single Collection'}
                  onSearch={reloadAction}
                  pageView={'inside_collection'}
                />
              </Dropdown.Item>
            ) : null}
          </Dropdown>
          <div className=" button-shared-style ml-2">
            <ManagePeopleCollectionButton
              //@ts-ignore
              collection={collection}
              collectionId={collection.id}
              sharedWith={collection.shared_with}
              context={'Single Collection'}
              onSearch={reloadAction}
              style={{ width: 'auto' }}
              TabOrInside={'inside_collection'}
            />
          </div>
          <div className="button-export">
            <ExportReport handleClickExport={handleClickExport} />
          </div>
        </div>
      </div>

      <DrawerCollection
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        collectionId={collection.id}
        message={''}
      />
    </div>
  );
};

export default CollectionHeader;
